import CommonDialog from '@src/new-components/Dialog/CommonDialog';
import React, { useState } from 'react';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import { AccordionSummary, AccordionDetails } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { StyledAccordion, StyledTipsList } from './index.style';

const TipsList = ({ tips, open, onClose }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const [expanded, setExpanded] = useState(null);

  const handleChange = (panel) => (_, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  return (
    <CommonDialog
      open={open}
      width="640px"
      styleContent={{
        padding: '24px',
        overflowX: 'hidden !important',
      }}
      disableAutoClose
      PaperProps={{
        sx: {
          height: 'max-content',
        },
      }}
      onClose={onClose}
      contentComponent={
        <StyledTipsList>
          {tips.map((item) => (
            <StyledAccordion
              sx={{
                '&.Mui-expanded': { backgroundColor: '#F4F5F7 !important' },
                '&::before': { display: 'none' },
              }}
              key={item.id}
              expanded={expanded === item.id}
              onChange={handleChange(item.id)}
            >
              <AccordionSummary
                expandIcon={
                  <ArrowDropDownRoundedIcon sx={{ color: '#1E164ECC' }} />
                }
                aria-controls={`faq-panel-content-${item.id}`}
                id={`faq-panel-header-${item.id}`}
                sx={{
                  margin: '0 !important',
                  minHeight: '0 !important',
                  padding: '0px !important',
                  '&.Mui-expanded': {
                    margin: '0 !important',
                  },
                  '& .MuiAccordionSummary-content': {
                    margin: '0 !important',
                    alignItems: 'center',
                  },
                }}
              >
                <Typography
                  className="faq-question"
                  variant="body-16-medium"
                  color="#1C1C1E"
                >
                  {item?.title?.[language]}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  padding: '0px !important',
                  marginTop: '8px !important',
                }}
              >
                <Typography
                  variant="body-14-regular"
                  color="#1C1C1EA3"
                  className="faq-answer"
                  dangerouslySetInnerHTML={{
                    __html: item?.description?.[language],
                  }}
                />
              </AccordionDetails>
            </StyledAccordion>
          ))}
        </StyledTipsList>
      }
      title={t('tipsForBestResults')}
    />
  );
};
export default TipsList;
